<template>
    <side-bar v-click-outside="hideSidebar" v-if="$permissions.sidebar()">
        <template slot="links">

            <sidebar-item :link="{ name: $t('common.accounts'), icon: 'tim-icons icon-multiple-19 text-orange' }"
                v-if="$permissions.sidebarAccount()">

                <sidebar-item :link="{ name: $t('common.users'), path: '/astral/ui/accounts/users' }"
                    v-if="$auth.hasOnePermission(['user.manage', 'user.manage-pilots', 'user.supervise'])">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.cohorts'), path: '/astral/ui/accounts/cohorts' }"
                    v-if="$auth.hasPermission('cohort.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.roles'), path: '/astral/ui/accounts/roles' }"
                    v-if="$auth.hasPermission('role.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.clients'), path: '/astral/ui/accounts/entities' }"
                    v-if="$auth.hasPermission('entity.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.owners'), path: '/astral/ui/accounts/owners' }"
                    v-if="$auth.hasPermission('owner.manage')">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.training'), icon: 'tim-icons icon-book-39 text-primary' }"
                v-if="$permissions.sidebarTraining()">

                <sidebar-item :link="{ name: $t('common.competencies'), path: '/astral/ui/training/competencies' }"
                    v-if="$auth.hasPermission('competency.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.competency-grids'), path: '/astral/ui/training/competency-grids' }"
                    v-if="$auth.hasPermission('grid.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.degrees'), path: '/astral/ui/training/degrees' }"
                    v-if="$auth.hasPermission('degree.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.registrations'), path: '/astral/ui/training/registrations' }"
                    v-if="$auth.hasPermission('registration.manage')">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.reports'), icon: 'tim-icons icon-line-chart text-info' }"
                v-if="$auth.hasPermission('dashboard.access-global-reports')"
            >
                <sidebar-item :link="{ name: $t('reports.cohorts'), path: '/astral/ui/reports/cohorts' }">
                </sidebar-item>

            </sidebar-item>

            <sidebar-links :link="{ name: $t('common.settings'), icon: 'tim-icons icon-settings text-default' }"
                v-if="$permissions.sidebarSettings()">

                <li class="nav-item" v-if="$auth.hasOnePermission(['xapi-extra.observe', 'xapi-extra.manage'])">
                    <a href="/lrs" class="nav-link" target="_blank">
                        <span class="nav-link-text">LRS</span>
                    </a>
                </li>

                <li class="nav-item" v-if="$auth.user.admin">
                    <a :href="docsUrl" class="nav-link" target="_blank">
                        <span class="nav-link-text">Documentation</span>
                    </a>
                </li>

                <sidebar-item v-if="$auth.user.admin"
                    :link="{ name: $t('common.socrates-export'), path: '/astral/ui/settings/socrates-export' }"
                >
                </sidebar-item>

            </sidebar-links>

        </template>
    </side-bar>
</template>

<script>
    export default {

        computed: {

            docsUrl() {
                return this.$baseURL + '/docs'
            }
        },

        methods: {

            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            }
        }
    }
</script>
